import { api } from '@config/api';
import type {
  AcaoLote,
  Candidato,
  DetalheParticipante,
  EmailsDaSelecao,
  FiltroLote,
  FiltrosPainel,
  ListaPainel,
  ResultadoLote,
  ResultadoRetentativa,
  SelecaoLote,
} from '../types/Painel';

export const POR_PAGINA_OPCOES = [25, 50, 100, 200] as const;
export const POR_PAGINA_PADRAO = 50;

const vazio = (v: unknown) => v === '' || v == null || (Array.isArray(v) && v.length === 0);
/** Marcar `sim` e `nao` é o mesmo que não filtrar: o parâmetro não vai (spec 24 B). */
const BINARIOS = ['respondeu', 'brinde', 'acessou', 'temEmail'];

/** Filtros → parâmetros da API (spec 13 R13/R14): vazios somem. Serve à lista, ao lote e à exportação. */
export function paramsDosFiltros<T extends Partial<FiltrosPainel>>(f: T) {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(f)) {
    if (vazio(v) || (BINARIOS.includes(k) && Array.isArray(v) && v.length === 2)) continue;
    out[k] = k === 'busca' ? String(v).trim() || undefined : v;
  }
  if (!out.ordenar) delete out.direcao;
  return out;
}

const selecaoDaApi = (selecao: SelecaoLote) =>
  'filtro' in selecao
    ? { ...selecao, filtro: paramsDosFiltros<Partial<FiltroLote>>(selecao.filtro) }
    : selecao;

/** `camiseta=a&camiseta=b` (sem colchetes), como o Nest espera. */
export const paramsSerializer = { indexes: null } as const;

export const painelService = {
  listar: (id: string, f: Partial<FiltrosPainel>) =>
    api
      .get<ListaPainel>(`/campanhas/${id}/participantes`, {
        params: paramsDosFiltros(f),
        paramsSerializer,
      })
      .then((r) => r.data),
  detalhe: (id: string, participanteId: string) =>
    api
      .get<DetalheParticipante>(`/campanhas/${id}/participantes/${participanteId}`)
      .then((r) => r.data),
  retentar: (id: string, participanteId: string) =>
    api
      .post<ResultadoRetentativa>(`/campanhas/${id}/escritas-axiis/retentativas`, {
        participanteId,
      })
      .then((r) => r.data),
  lote: (id: string, acao: AcaoLote, selecao: SelecaoLote) =>
    api
      .post<ResultadoLote>(`/campanhas/${id}/participantes/lote`, {
        acao,
        selecao: selecaoDaApi(selecao),
      })
      .then((r) => r.data),
  emailsDaSelecao: (id: string, selecao: SelecaoLote) =>
    api
      .post<EmailsDaSelecao>(`/campanhas/${id}/participantes/emails`, {
        selecao: selecaoDaApi(selecao),
      })
      .then((r) => r.data),
  incluir: (id: string, profissionalIds: number[]) =>
    api
      .post<ResultadoLote>(`/campanhas/${id}/participantes/incluir`, { profissionalIds })
      .then((r) => r.data),
  candidatos: (id: string, busca: string) =>
    api
      .get<Candidato[]>(`/campanhas/${id}/participantes/candidatos`, { params: { busca } })
      .then((r) => r.data),
};
